// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/styling-" + {"13921":"efcf63118018dbaf2ef2","63598":"5097533d921f1eea007d"}[chunkId] + ".css";
};